var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mounter",staticClass:"full"},[(_vm.rAPI)?_c('button',{staticClass:"button toucher z-50 fixed bottom-0 right-0 p-3 text-2xl",on:{"click":_vm.rAPI.initAudio}},[_vm._v("🎸")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }